import { useEffect, useRef } from 'react';

import { FAQ } from '@components/FAQ';
import { useIsInView } from '@hooks/useIsInView';
import { useTrackingContext } from '@tracking/Provider/Context';
import {
  useTrackSignupIpFaqExpanded,
  useTrackSignupIpFaqsDisplayed,
} from '@tracking/trackingEvents';

import { faqSections } from './sections';

const IncomeProtectorFAQ = () => {
  const faqRef = useRef<HTMLHeadingElement>(null);
  const isInView = useIsInView(faqRef);

  const { trackingContexts } = useTrackingContext();
  const trackExpanded = useTrackSignupIpFaqExpanded();
  const trackDisplayed = useTrackSignupIpFaqsDisplayed();
  useEffect(() => {
    if (isInView) {
      trackDisplayed({}, { contexts: trackingContexts });
    }
  }, [isInView, trackDisplayed, trackingContexts]);

  const handleAccordionChange = (question: string, isExpanded: boolean) => {
    if (!isExpanded) {
      return;
    }

    trackExpanded(
      {
        question,
      },
      { contexts: trackingContexts }
    );
  };

  return (
    <FAQ
      ref={faqRef}
      sections={faqSections}
      onAccordionChange={handleAccordionChange}
    />
  );
};

export { IncomeProtectorFAQ };
